import { isFilteredProductResponse, isValidProductLevel, isValidQuantityPackApiName } from '../utils/typeguards';
export const reduceProductsResponse = data => {
  const products = data.filter(isFilteredProductResponse);
  const skuIdToProductVersion = products.reduce((acc, product) => {
    product.productVersions.forEach(version => {
      acc[version.skuId] = version;
    });
    return acc;
  }, {});
  const skuMap = Object.values(skuIdToProductVersion).reduce((acc, productVersion) => {
    acc[productVersion.skuId] = productVersion;
    productVersion.quantityPackDetails.forEach(quantityPack => {
      acc[quantityPack.skuId] = quantityPack;
    });
    return acc;
  }, {});
  const productApiNameMapToProduct = products.reduce((acc, product) => {
    const {
      apiName,
      currentSkuId
    } = product;
    const existingProduct = acc[apiName];
    if (existingProduct && currentSkuId < existingProduct.currentSkuId) {
      return acc;
    }
    acc[apiName] = product;
    return acc;
  }, {});
  const productLineLevelToProduct = products.reduce((acc, product) => {
    const {
      productLine,
      productLevel
    } = product;
    if (productLine && isValidProductLevel(productLevel)) {
      if (!acc[productLine]) {
        acc[productLine] = {};
      }
      acc[productLine][productLevel] = product;
    }
    return acc;
  }, {});
  const quantityPackApiNameToProduct = Object.values(skuIdToProductVersion).reduce((acc, productVersion) => {
    productVersion.quantityPackDetails.forEach(quantityPack => {
      const {
        productApiName,
        quantityPackApiName
      } = quantityPack;
      const product = productApiNameMapToProduct[productApiName];
      if (isValidQuantityPackApiName(quantityPackApiName)) {
        if (!acc[quantityPackApiName]) {
          acc[quantityPackApiName] = {};
        }
        acc[quantityPackApiName][productApiName] = product;
      }
    });
    return acc;
  }, {});

  /**
   * @deprecated Only used for backward compatibility
   */
  const productMap = products.reduce((acc, product) => {
    var _acc$product$id;
    const {
      id
    } = product;
    if (product.currentSkuId < (acc === null || acc === void 0 || (_acc$product$id = acc[product.id]) === null || _acc$product$id === void 0 ? void 0 : _acc$product$id.currentSkuId)) {
      return acc;
    }
    acc[id] = Object.assign({}, product, {
      productVersions: product.productVersions.map(({
        skuId
      }) => skuId)
    });
    return acc;
  }, {});

  /**
   * @deprecated Only used for backward compatibility
   */
  const apiNameToProductId = Object.values(productMap).reduce((acc, {
    apiName,
    id
  }) => {
    acc[apiName] = id;
    return acc;
  }, {});

  /**
   * @deprecated Only used for backward compatibility
   */
  const productLineLevelToProductId = products.reduce((acc, {
    productLine,
    productLevel,
    id
  }) => {
    if (productLine && isValidProductLevel(productLevel)) {
      acc[productLine] = Object.assign({}, acc[productLine], {
        [productLevel]: id
      });
    }
    return acc;
  }, {});

  /**
   * @deprecated Only used for backward compatibility
   */
  const quantityPackApiNameToProductId = Object.values(skuIdToProductVersion).reduce((acc, productVersion) => {
    productVersion.quantityPackDetails.forEach(quantityPack => {
      const {
        productId,
        productApiName,
        quantityPackApiName
      } = quantityPack;
      if (isValidQuantityPackApiName(quantityPackApiName)) {
        acc[quantityPackApiName] = Object.assign({}, acc[quantityPackApiName], {
          [productApiName]: productId
        });
      }
    });
    return acc;
  }, {});
  return {
    skuIdToProductVersion,
    skuMap,
    productApiNameMapToProduct,
    productLineLevelToProduct,
    quantityPackApiNameToProduct,
    rawProductList: products,
    productMap,
    apiNameToProductId,
    productLineLevelToProductId,
    quantityPackApiNameToProductId
  };
};